import { render, staticRenderFns } from "./voiceUpload.vue?vue&type=template&id=c4b4bfde&scoped=true&"
import script from "./voiceUpload.vue?vue&type=script&lang=js&"
export * from "./voiceUpload.vue?vue&type=script&lang=js&"
import style0 from "./voiceUpload.vue?vue&type=style&index=0&id=c4b4bfde&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b4bfde",
  null
  
)

export default component.exports